import type { TranslationInterface } from './translation.types';

export const nlLocale: TranslationInterface = {
  'write-a-message': 'Schrijf een bericht...',
  'session-closed-lead': 'Uw probleem is opgelost!',
  'new-conversation': 'Nieuw gesprek',
  'welcome-title': 'Welkom bij onze supportchat',
  'welcome-description':
    'We zijn hier om te helpen! Begin een gesprek en we nemen zo snel mogelijk contact met u op.',
  'your-name': 'Uw naam',
  'your-email': 'Uw e-mailadres',
  'start-chat': 'Praat met ondersteuning',
  'starting-chat': 'Verbinding maken...',
  'i-need-more-help': 'Ik heb nog meer hulp nodig',
  'this-was-helpful': 'Mijn vraag is opgelost',
  optional: 'Optioneel',
  'no-conversations-yet': 'Nog geen gesprekken',
  'back-to-conversations': 'Terug naar gesprekken',
  'closed-conversations': 'Afgesloten gesprekken',
};
